function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M80.186 22.247C80.186 22.247 76.375 27.888 76.375 30.434 76.2727 32.539 77.8962 34.3284 80.0012 34.4308 82.1063 34.5331 83.8957 32.9096 83.998 30.8045 84.004 30.6811 84.004 30.5574 83.998 30.434 84 27.9 80.186 22.247 80.186 22.247Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M81.34 14 80.35 11.639C80.137 11.134 79.5573 10.8945 79.05 11.102L62.113 18.102C60.7024 18.6855 59.488 19.6601 58.613 20.911L54.5 26.792 52.434 25.871C51.9297 25.6459 51.3383 25.8722 51.1132 26.3765 51.1131 26.3767 51.1131 26.3768 51.113 26.377L49.513 29.977 41.741 22.637C40.6255 21.5839 39.149 20.9981 37.615 21L18 21C14.6863 21 12 23.6863 12 27L12 78C12 81.3137 14.6863 84 18 84L59 84C62.3137 84 65 81.3137 65 78L65 40.932C64.9954 39.0186 64.0763 37.2228 62.527 36.1L64.249 32.239C64.475 31.7361 64.2513 31.1452 63.749 30.918L61.672 29.992 64.083 24.1C64.6921 22.6153 65.8705 21.4365 67.355 20.827L80.8 15.309C81.3102 15.0976 81.5524 14.5126 81.341 14.0023 81.3407 14.0016 81.3403 14.0008 81.34 14ZM30.485 34C28.8936 34.0002 27.3674 33.3682 26.242 32.243L21 27 36.025 27C37.0462 27.0001 38.0286 27.3908 38.771 28.092L45.027 34Z",
  fill: "currentColor"
});

var SvgDiesel = function SvgDiesel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    id: "Icons_Fuel1",
    overflow: "hidden",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiesel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/diesel.750307d6.svg";
export { ForwardRef as ReactComponent };